var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.212936 10.0405C0.280632 10.1142 0.360998 10.1726 0.449448 10.2125C0.537897 10.2524 0.632702 10.2729 0.728439 10.2729C0.824179 10.2729 0.918982 10.2524 1.00743 10.2125C1.09588 10.1726 1.17625 10.1142 1.24394 10.0405L8.81894 1.81581C8.95583 1.66694 9.14143 1.58331 9.33495 1.58331C9.52846 1.58331 9.71405 1.66694 9.85094 1.81581L17.4239 10.0416C17.5608 10.1902 17.7463 10.2736 17.9397 10.2734C18.133 10.2732 18.3184 10.1894 18.4549 10.0405C18.5915 9.89156 18.6682 9.68966 18.668 9.47923C18.6678 9.2688 18.5908 9.06706 18.4539 8.91841L10.8809 0.695896C10.4704 0.250277 9.91426 2.97523e-05 9.33444 2.97016e-05C8.75463 2.96509e-05 8.19847 0.250277 7.78793 0.695896L0.214935 8.92167C0.0788594 9.07004 0.00226983 9.271 0.00189216 9.48064C0.0015183 9.69027 0.0773907 9.89155 0.212936 10.0405Z",
    fill: "#323233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBlack);
export default __webpack_public_path__ + "static/media/chevron-up-black.369b83fdd54bbfbde6edb8587e654772.svg";
export { ForwardRef as ReactComponent };